RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.IntervalDropdown = Marionette.ItemView.mixin({
        template: '#dashboardIntervalDropdownTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            userSettingsChanged: RivalIQ.apps.Dashboard.mixins.UserSettingsChanged
        },

        behaviors: {
            DropdownSelector: {}
        },

        dashboardModelEvents: {
            'change': 'render'
        },

        onUserSettingsChanged: function () {
            const me = this;

            me._selectInitial();
        },

        defaultSelector: function () {
            const selectedInterval = RivalIQ.state.view.getGroupedByInterval();
            return `[data-interval="${selectedInterval}"]`;
        },

        onSelectDropdown: function (data) {
            const me = this;

            RivalIQ.state.view.temporarilyOverrideGroupedByInterval(data.interval);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangedGroupByInterval, {
                widgetId: me.dashboardModel.widgetId,
                curationId: me.dashboardModel.getCuration().id
            });
        },

        serializeData: function () {
            const me = this;

            const timePeriod = me.getProp('timePeriod');

            const numCompleteWeeks = RivalIQ.utils.timePeriod.numCompletePeriods(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd, 'week');
            const numCompleteMonths = RivalIQ.utils.timePeriod.numCompletePeriods(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd, 'month');

            return {
                intervals: [{
                    id: 'auto',
                    name: 'Auto'
                }, {
                    id: RivalIQ.enums.timePeriod.interval.daily,
                    name: 'Day'
                }, {
                    id: RivalIQ.enums.timePeriod.interval.weekly,
                    name: 'Week',
                    disabled: numCompleteWeeks < 2
                }, {
                    id: RivalIQ.enums.timePeriod.interval.monthly,
                    name: 'Month',
                    disabled: numCompleteMonths < 2
                }]
            };
        },

        onRender: function () {
            const me = this;

            me._selectInitial();
        },

        _selectInitial: function () {
            const me = this;

            const dropdownBehavior = _.find(me._behaviors, function (behavior) {
                return (behavior instanceof RivalIQ.behaviors.DropdownSelector);
            });
            dropdownBehavior.selectInitial();
        }
    });

    views.IntervalDropdown.getGroupByInterval = function (props) {
        const selectedInterval = RivalIQ.state.view.getGroupedByInterval();

        if (selectedInterval === 'auto') {
            const metricInterval = RivalIQ.metric.timePeriod.getDefaultInterval(props.timePeriod);
            return metricInterval;
        } else {
            return selectedInterval;
        }
    };

});
